/*
 * TODO -- really need to clean up this workflow with a model, especially the handling of side panes and widths.
 * Note: notes panel (right) always created so for time being-put ajax-spinner & more menu in there
 * */

var $ = require('jquery'),
    SubApp = require('../common/SubApp'),
    LayoutView = require('./layoutView'),
    LeftSideModel = require('./panelCommon/models/leftPane'),
    RightSideModel =  require('./panelCommon/models/rightPane');

require('backboneFwd');

var instVars = {
    vChannel: null,
    leftSideModel: null,
    rightSideModel: null,
    layoutView: null
};


module.exports = SubApp.extend({

	constructor: function(options, id) {
        _.extend( this, instVars, options, {id: id} );
        SubApp.prototype.constructor.apply(this, arguments);
    },

    initialize: function() {

        var ch = this.channel,
            rsm = this.rightSideModel = new RightSideModel([], {lChannel: ch}), // all objects could extend from SA interface
            lsm = this.leftSideModel = new LeftSideModel(),
            mEvents = this.sideModelEvents;
           
        this.layoutView = new LayoutView({ lChannel: ch });
        this.bindEntityEvents(lsm, mEvents);
        this.bindEntityEvents(rsm, mEvents);

        /* key: link vChannel to this channel events -- TODO: in subapp ... prefix? */

       Backbone.fwd.call(ch, this.vChannel);  //(apply use if more)

    },
    /* note: these are inner subscriptions (lChannel) -- (and outer forwarded to it */
    subscriptions: {
        'layout:sideHeaderTabClick':        'headerTabButtonClickCB', //(combo with change: currentSubPane of model?
        'layout:openToSubPane':             'openToSubPane',
        'layout:closeSidePanel':            'closePane',
        'layout:toggleSidePanel':           'toggleSidePanel',
        'layout:setPaneWidth':              'setPanelWidth', /* from drag end */
        'vChannel:openToSubPane':           'openToSubPane', //if from other change (eg active note -->)
        'vChannel:resizeSidesIfOverlap':    'resizeSidesIfOverlap', // TODO: fwd
        'layout:repositionShapeDialog':     'repositionShapeDialog' // ( this one just a fwd )
    },

    /**
     * Post change
     * could forward (or store on model for clarity)
     */
    sideModelEvents: {
        'change:isOpen':                    'paneToggledOpen',  //note: could put hook in here like old paneModel openOrPaneChangeCB
        'change:currentSubPane':            'subPaneChange',
        'change:width':                     'paneWidthChanged',
        'change:isCovering':                'paneCoveringToggled',
        'panel:postToggleSubPane':          'toggleSubPaneCB' //from within region
    },
    commands: {
        changePage: function(opts) {

            _.invoke( [this.request('navView'), this.request('centerHeaderView'),  this.request('overflowMenu') ], 'updatePostPageChange', opts);

        },
        toggleHeaderViewMode: function() {

            var centerHeader =  this.request('centerHeaderView'),
                overflowMenu = this.request('overflowMenu'),
                leftHeaderView = this.layoutView.getRegion('leftHeader').currentView,
                toggleFn = 'toggleHeaderViewModeState';

            centerHeader[toggleFn].apply( centerHeader, arguments );
            overflowMenu[toggleFn].apply( overflowMenu, arguments );
            leftHeaderView[toggleFn].apply( leftHeaderView, arguments );

        },
        // Should pass this via channel rather than through direct reference
        createNewNoteMenu: function() {
            var rightHeader = this.layoutView.getRegion('rightHeader').currentView;
            rightHeader.triggerMethod.apply(rightHeader, ['createNewNoteMenu'].concat( _.toArray(arguments) ));
        },
        updateFullTextNoteCountAndCaption: function() {
            this.trigger.apply(this, ['updateFullTextSearchCount'].concat( _.toArray(arguments)) );
        },
        changeScale: function() {
            var header = this.request('centerHeaderView');
            header.updatePostScale.apply(header, arguments);
        },

        /*
        * Open according to settings on viewer load.
        * Really the state of the panels ...
        * TODO:
        * - incorp new api for doc level options ... those would supercede prDocLayout state
        * - set options of what to open higher level
        * - document actions
        * */

        setInitialLayout: function(options) {

            var r = this.rightSideModel,
                l = this.leftSideModel,
                vChannel = this.vChannel,
                prDocLayoutState = options.prDocLayoutState,
                lastPane;

            if ( options.fullTextQuickView ) { // use prior layout state here?

                this._coverWithPane(r, 'fullText');

            } else {

                /* LEFT*/
                if (!prDocLayoutState) {

                    if ( vChannel.request('includeFindAndRedactModule') && vChannel.request('settings').findAndRedact() )
                    {
                        // Search is now performed on render: canvas shapes are drawn when ready from viewer.state
                        this.openToSubPane( l, 'findAndRedact' );
                    }
                    else
                    {
                        ( vChannel.request('includeIndexesModule') && options.autoDisplayIndexes ) &&
                            this.openToSubPane(l, 'default');
                    }


                } else {

                    var leftPaneSt = prDocLayoutState.leftPane,
                        lpWasOpen = leftPaneSt.isOpen;

                    lastPane = leftPaneSt.currentSubPane;

                    if (lpWasOpen) {

                        /* --  Open to what it had previously -- if approp to current doc -- viewer would have SAME INSTANCE SETTINGS -- */
                        if ( lastPane === 'indexInfo' && vChannel.request('includeIndexesModule') ) {

                            this.openToSubPane(l, 'default'); //(indexes)

                        } else if ( lastPane === 'thumbs' && vChannel.request('allowThumbnails') ) {

                            this.openToSubPane(l, 'thumbs');

                        } else if ( lastPane === 'findAndRedact' && vChannel.request('includeFindAndRedactModule') ) {

                            /* -- There are things we could persist with the findAndRedact model, but not doing now -- */
                            this.openToSubPane(l, 'findAndRedact');

                        }

                    }

                }

                /* RIGHT */
                var docHasNotes = options.docHasNotes,
                    docHasVisibleNotes = options.docHasVisibleNotes,
                    forceOpenNotes = options.forceOpenToNotes;

                /* forceOpenNotes: override others */
                if (forceOpenNotes && docHasNotes) {
                    this.openToSubPane(r, 'notes');
                    return;
                }


                var fullTextQuery = options.fullTextQuery;

                if (!prDocLayoutState) {

                    typeof fullTextQuery === 'string' //(allow empty string search)
                        ? this.openToSubPane(r, 'fullText') //this.openToSubPane(r, !forceOpenNotes ? 'fullText' : 'default') -- this now handled above
                        : docHasVisibleNotes && this.openToSubPane(r, 'default');

                } else {

                    var rightPaneSt = prDocLayoutState.rightPane,
                        rpWasOpen = rightPaneSt.isOpen;

                    lastPane = rightPaneSt.currentSubPane;

                    /* open to what it had previously -- if approp to current doc -- viewer would have SAME INSTANCE SETTINGS */
                    if (rpWasOpen) {

                        /*force open to notes handle above */
                        if (lastPane === 'fullText' && fullTextQuery)
                            this.openToSubPane(r, 'fullText');

                        /* notes panel always printed, force handle above */
                        if (lastPane === 'notes')
                            this.openToSubPane(r, 'notes');

                    }

                }

            }
        },
        renderZoomView: function(scaleModel) {
            this.layoutView.getRegion('centerHeader').currentView.triggerMethod('renderZoomView', scaleModel);
        },
        showModal: function() {
            var l = this.layoutView;
            l.triggerMethod.apply(l, ['showModal'].concat(_.toArray(arguments)));
        },
        closeModal: function() {
            this.layoutView.triggerMethod('closeModal');
        },
        toggleFullScreen: function(isFullScreen) {
            var lsm = this.leftSideModel,
                rsm = this.rightSideModel;
            this.layoutView.triggerMethod('toggleFullScreen', isFullScreen);
           // need to resize the cover (if it is covering -- could also reset ratios of the others .....
            rsm.isCovering() && this._coverWithPane(rsm, rsm.get('currentSubPane'));
            lsm.isCovering() && this._coverWithPane(lsm, lsm.get('currentSubPane'));
        },
        toggleRotateEnabled: function(disable) {
            var centerHeader = this.request('centerHeaderView'),
                overflowMenu = this.request('overflowMenu');
            _.invoke([centerHeader, overflowMenu], 'toggleRotateEnabled', disable);
        },
        //todo: apply higher level, then trickle here
        togglePaneCover: function(pane, isCovering) { //todo: have in reaction
            this.vChannel.command('togglePaneIsCoveringLayout', isCovering);
            this.command('toggleRotateEnabled', isCovering); //todo: best served with load images -- it goes with this, same for zoom
            _.invoke([this.request('centerHeaderView'), this.request('overflowMenu')], 'toggleScaleEnabled', isCovering);
        },
        setPanelIsResizing: function(val) {
            this.vChannel.command('setPanelIsResizing', val);
        },
        updateNoteCount: function(num) {
            this.trigger('updateNoteCount', num);
        },
        /**
         * Toggle Ability to Rotate If Page Has unknown Dims, Image Load Error.
         * Old notes: for doc mode -- check if image failure -- not retried every time error like pg mode -- actually now should be?
         * Note: also hidden via css if no renderable pages.
         * //TODO: was in render also also -- put into template:
         *      !vc.request('activeDocHasNoPages') && this.setDisableHandlers.call(this); ... need in headerHeader?
         */
        pageImgLoadError: function(page) {
            this.request('centerHeaderView').toggleRotateEnabled( page.imgLoadFailed() ? 1 : 0 ); // need check -- see above ?
            this.request('overflowMenu').toggleRotateEnabled(true);
        },
        stopLoadingIndicator: function() {
            var rightHeader =  this.layoutView.getRegion('rightHeader').currentView;  
            rightHeader && rightHeader.command('stopAjaxSpinner');
        },
        activeNoteChange: function(note, options) {
            this._activeOrExpandedNoteChange.apply(this, arguments);
        },
        expandedNoteChange: function() {
            this._activeOrExpandedNoteChange.apply(this, arguments);
        }
    },
    requests: {
        vChannel: function() {
            return this.vChannel;
        },
        activeNote: function() {
            return this.vChannel.request('activeNote');
        },
		notesEl: function() {
			return this.layoutView.getRegion('rightContent').currentView.ui.notes;
		},
        fullTextEl: function() {
            return this.layoutView.getRegion('rightContent').currentView.ui.fullText;
        },
        indexesEl: function() {
            return this.layoutView.getRegion('leftContent').currentView.ui.indexes;
        },
        thumbsEl: function() {
            return this.layoutView.getRegion('leftContent').currentView.ui.thumbNails;
        },
        findAndRedactEl: function() {
            return this.layoutView.getRegion('leftContent').currentView.ui.findAndRedact;
        },
        rightSideModel: function() {
            return this.rightSideModel;
        },
        leftSideModel: function() {
            return this.leftSideModel;
        },
        setScaleFn: function() {
            return this.vChannel._commands.setScale.callback;

        },
        viewMode: function() {
            return this.vChannel.request('viewMode');
        },
        wrapper: function() {
            return this.layoutView.$el; //(the $el of the layout) -- todo: implement in places
        },
        layoutWidth: function(excludeDragger) { /* exclude dragger from the width calculation, otherwise won't be visible and user won't be able to close covered panel (margin-right of center) */
            return this.layoutView.$el.width() - (excludeDragger ? 8 : 0); //
        },
        modalView: function() {
            return this.layoutView.getRegion('modal').currentView;
        },
        viewerLoaded: function() {
            return this.vChannel.request('viewerLoaded');
        },
        centerHeaderView: function() {
            return this.layoutView.getRegion('centerHeader').currentView;
        },
        navView: function() {
            return this.layoutView.getRegion('centerHeader').currentView.children.findByCustom('nav');
        },
        rotateView: function() {
            return this.request('centerHeaderView').children.findByCustom('rotate');
        },
        overflowMenu: function() {
            return this.layoutView.getRegion('rightHeader').currentView.request('overflowMenu');
        },

        /*
         * Region is a marionette region to show the view inside of -- returns a $dfd.
         * Do not return the $dfd within a closure!!! this will cause memory leak
         */
        renderLayout: function(region, options) {

            var $dfd = $.Deferred(),
                settings = _.extend(options, {
                    leftModel: this.leftSideModel,
                    rightModel: this.rightSideModel,
                    lChannel: this.channel
                }),
                lv = this.layoutView;

            lv.onShow = function(view) {
                $dfd.resolve(view.centerContent);
            };

            region.show(lv, settings);

            return $dfd.done(function(centerRegion) {
                return centerRegion;
            }).promise();

        },
        pdfWrapper: function() {
            return this.vChannel.request('pdfWrapper');
        },
        /* note: no state model, so derive from the side models -- currently used to set initial layout on doc reset prior to destroy */
        state: function() {
            return {
                leftPane: this.leftSideModel.toJSON(),
                rightPane:  this.rightSideModel.toJSON()
            };
        }
	},

    // perhaps a pre? where it could exit -- see right
    toggleSubPaneCB: function( pane ) {
        pane.get('side') === 'left' &&
            this.vChannel.command( 'postToggleLeftSubPanel', pane ); //(for the thumbnails
    },

    //TODO -- put in another ...
    fullTextPaneWidthChange: function() {
        this.vChannel.trigger('vChannel:fullTextPaneWidthChange');
    },
    resizeSidesIfOverlap: function() {
        this.layoutView.onResizeSidesIfOverlap(this.leftSideModel, this.rightSideModel); //direct for perf (no triggerMethod)
    },

    // TODO: pass all open to subpane through here ... is it ?
    // ...could make much clearer but working
    // rid direct fn calls and forward through one entry point
    openToSubPane: function(pane, subPane, options) {

        !options && (options = {});

        (typeof pane === 'string') &&
            (pane = this[pane + 'SideModel']);

        var lastOpenPane = pane.get('lastOpenSubPane'),
            oppPane = this._getOppositePane(pane);

        subPane = !subPane && lastOpenPane
            ? lastOpenPane //closing
            : subPane; //open to the subPane (can be via entry or hover) -- ... if want default for hover use 'default'

        pane.isCovering() && _.extend(options, { //if the pane is already covering -- example: full screen toggle -- need to include the dragger with for it to show
            containerWidth: this.request('layoutWidth', true)
        });

        /* If opposing pane is covering, close it before opening this one */
        if ( oppPane.isCovering() ) {
            oppPane.close();
            oppPane.openToSubPane( oppPane.get('lastOpenSubPane'), options );
        }

        pane.openToSubPane(subPane, options);

    },

    headerTabButtonClickCB: function(pane, clickedSubPanel) {

        if (pane.get('isOpen')) {

            pane.get('currentSubPane') === clickedSubPanel
                ? this.closePane(pane)
                : this.openToSubPane.apply(this, arguments);

        } else {

            this.openToSubPane.apply(this, arguments);

        }

    },
    paneToggledOpen: function(pane, isOpen, options) {

        var sidePanel = this._getSideView(pane),
            self = this,
            args = Array.prototype.slice.call(arguments),
            vCh = this.vChannel;

        $.when(
            sidePanel.toggleOpen(pane)
        ).then(function() {

            var panelCenter = self.layoutView.children.findByCustom('panelCenter');

            panelCenter.updatePostSidePaneOpenChange.apply(panelCenter, args).done( function() {

                vCh.command('setScale'); // could mediate more and only do if fit width/auto in vChannel (and not if in pdf mode)
                self.resizeSidesIfOverlap();
                self.channel.trigger( 'layout:repositionShapeDialog' ); // note: could double with set scale but hardly a perf hit

            });

        });
    },
    /*
     * From pane toggle or open of pane --  note: side headers must render first
     * 'Toggle Header and Side Views
     */
    subPaneChange: function(pane, subPane, options) {

        var lastOpenPane = pane.previous('currentSubPane');
        pane.set({ lastOpenSubPane: !lastOpenPane ? subPane : lastOpenPane});

        this._getSideView(pane).toggleSubPane( pane, subPane, _.extend(options, {vChannel: this.options.vChannel}) );

        this.layoutView[ pane.get('side') === 'left' ? 'leftHeader' : 'rightHeader'].currentView.toggleActivePane(pane, subPane);
    },
    setPanelWidth: function(panel, width, options) {  //now used by the enddrag ... should be callback
        panel.updateWidth(width, options);
    },
    paneWidthChanged: function(pane, newWidth, options) {

        var side = this._getSideView(pane);
        side.updatePosition.apply(side, arguments);
        options.fromResize && this.layoutView.children.findByCustom('panelCenter').updatePosition(pane); //DOES THE CENTER ...
        (pane.isCovering() && options.fromDrag) && pane.set('isCovering', false);
        ////(for recalcing the offsets):
        //could check options in mediator fn (eg which side)
        // //todo: subscribe and publish anyway (perf check on mediator)
        (pane.get('side') === "right" && pane.get('currentSubPane') === 'fullText') &&
            this.vChannel.trigger('layout:fullTextPaneWidthChange'); //todo: mediate
    },

    // open pane 100%, closing others; returns false is the pane model doesn't have the subPanel -- (callback for the command)
    _coverWithPane: function(sidePane, subPane) {

        if (!sidePane.hasSubPane(subPane))
            return false;

        this.closePane(this._getOppositePane(sidePane)); //(def for reset)

        this.openToSubPane(sidePane, subPane, {
            cover: true,
            forceOpen: true,
            containerWidth: this.request('layoutWidth', true) /* want dragger visible */
        });

        return true;

    },
    paneCoveringToggled: function() {  //todo: mediate
        this.command.apply(this, ['togglePaneCover'].concat(_.toArray(arguments)));
    },
    _getOppositePane: function(pane) {
        return this[(pane.get('side') === 'right' ? 'left' : 'right') + 'SideModel'];
    },
    _getSideView: function(pane) {
        return this.layoutView[ (pane.get('side') === 'left' ? 'left' : 'right') + 'Content'].currentView;
        //return this.layoutView.children.findByCustom('panel' + (pane.get('side') === 'left' ? 'Left' : 'Right'));
    },

    /* pane: either the string or model */
    closePane: function(pane) {

        typeof pane === 'string' &&
            (pane = this[pane + 'SideModel']);

        pane.close();

    },
    // Toggle the pane open / closed -- now called from hotkeys
    // Pane: 'left' or 'right'
    toggleSidePanel: function( pane ) {

        var sidePanelModel = pane === 'left'
            ? this.request('leftSideModel')
            : this.request('rightSideModel');

        sidePanelModel.isOpen()
            ? this.trigger('layout:closeSidePanel', pane)
            : this.trigger('layout:openToSubPane', pane);

    },

    _activeOrExpandedNoteChange: function(note, options) {

        // TODO: should have a more centralized enable/disable rotate ...
        if ( !this.vChannel.request('activeDocHasNoPages') ) {
            this.command('toggleRotateEnabled', options.disableRotation );
        }

        this.channel.trigger('rightHeader:toggleNewNoteMenu', note != null);

    },
    // ( trigger would cause recursion, so just command on vChannel and forward fow now )
    repositionShapeDialog: function() {
        this.vChannel.command('repositionShapeDialog');
    },

    onBeforeDestroy: function() {

        var lsm = this.leftSideModel,
            rsm = this.rightSideModel,
            smEvents = this.sideModelEvents;

        this.layoutView.destroy();
        this.unbindEntityEvents(lsm, smEvents);
        this.unbindEntityEvents(rsm, smEvents);

        _.invoke([lsm, rsm], 'destroy');

    },
    destroy: function() {
        SubApp.prototype.destroy.call(this);
        this.stopListening();

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/layout.js
 ** module id = 710
 ** module chunks = 0
 **/